import React,{useState} from 'react';
import EmployAside from '../aside';
import MailIndex from './mail-index';

const BoitesMail = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <MailIndex setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default BoitesMail;